$(function() {
  var $header = $(".feature_image .header");
  

  

  if ($(window).width() >= 768) {
    
  }

  


  $('.search_link').on("click", function(){
    $(this).attr("href", $(this).attr("href") + $(".mm-search input").val());
  })

  if ($('html').hasClass('ie')) {
    $('.icon-cart').on("click", function() { window.location = '/cart'; return false; });
  } else {
    $('.icon-cart, .icon-menu').on("click", function(e) {
      $('#search').hide();
    });
  }

  $('#search-toggle, .search-close').on('click', function(e) {
    $('.search-close, .search-submit').css('padding-top', $('.header').height() + 50 + 'px')
    if($('#search').is(":visible") && $(window).scrollTop() == 0) {
      

      if($('body.feature_image').length) {
        $('.logo img').attr('src', $('.logo img').data('src-home'));
      }
    } else {
      $header.addClass('header_bar');
      $('.logo img').attr('src', $('.logo img').data('src'));
    }

    if($('#search').hasClass("fadeIn")) {
      $('#search').removeClass("fadeIn").hide();
    } else {
      $('#search').show().addClass("fadeIn").find('input').focus();
    }

    e.stopPropagation();
    e.preventDefault();
  })

  $(".icon-search").on('click', function(e) { $(this).parent('form').submit(); });

  

  $('.mm-search input').keypress(function(e) {
    if(e.which == 13) {
      window.location = '/search?type=product&q=' + $(this).val();
    }
  });

  
  
  

  

  

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });
  $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });

  

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function() {
    if ($(window).width() <= 767) {
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
      }
    }
  });

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      
      setTimeout($.fancybox.close, 2000);
    });
  });

  var $notify_form = $('.notify_form .contact-form');
  $notify_form.each(function() {
    var $nf = $(this);
    $nf.on("submit", function (e) {
      if($nf.find('.notify_email').val() != "") {
        $.ajax({
          type: $nf.attr('method'),
          url: $nf.attr('action'),
          data: $nf.serialize(),
          cache: false,
          success: function (data) {
            $notify_form.fadeOut("slow", function(){
              $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
            });
          }
        });
      } else {
        $nf.prev('.message').html("Please provide a valid email address.");
      }
      e.preventDefault();
    });
  });

  

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
  
    $cart = $("#cart");
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      cache: false,
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }
  
  $(document).on("change", "#cart input.quantity", function() {
    ajaxSubmitCart();
  });

  $(document).on("click", ".minus", function() {
    var quantity = parseInt($(this).next("input").val());
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    if (quantity == 0) {
      $(this).closest('li.cart_item').addClass('animated fadeOutUp')
      setTimeout(ajaxSubmitCart, 500);
    } else {
      ajaxSubmitCart();
    }
  });
  $(document).on("click", ".trashcan", function() {
    var quantity = 0;
    $(this).closest('.cart_item_body').find("input").attr("value", quantity);
    $(this).closest('li.cart_item').addClass('animated fadeOutUp');
    setTimeout(ajaxSubmitCart, 500);
  });
   $(document).on("click", ".plus", function() {
   
    var quantity = parseInt($(this).prevAll("input").first().val());
    var itemTitle = $(this).closest("div").parent("div").siblings(".itemtitle").text().toLowerCase();
    var prodTitle = $(this).closest("div").parent("div").siblings(".itemtype").text().toLowerCase(); 
    if(prodTitle.length > 1){
      if(prodTitle.indexOf("1 ") >-1 || prodTitle.indexOf("single") >-1 || prodTitle.indexOf("presale") >-1 || itemTitle.indexOf("new year") >-1 || itemTitle.indexOf("3-") >-1){
        quantity += 1;
        if (quantity >= 6){
        }else{ 
          $(this).parent().find(".quantity").attr("value",quantity);
          ajaxSubmitCart();
        }
      }else if (prodTitle.indexOf("3 ") >-1){
        quantity += 1;
        if (quantity >= 3){
        }else{ 
          quantity += 1;
          $(this).parent().find(".quantity").attr("value",quantity);
          ajaxSubmitCart();
        }
      }else
      {
       
        quantity += 1;
        $(this).parent().find(".quantity").attr("value",quantity);
          ajaxSubmitCart();
      }
    }else{
      if(itemTitle.indexOf("bundle")<0||itemTitle.indexOf("system")<0){
        quantity += 1;
        if (quantity > 6){
        }else{ 
          $(this).parent().find(".quantity").attr("value",quantity);
          ajaxSubmitCart();
        }
      }else
      {
        quantity += 1;
        $(this).parent().find(".quantity").attr("value",quantity);
          ajaxSubmitCart();
      }
    }
  });


  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);
    
    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
    }
    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')));
        $("body").on('DOMSubtreeModified', ".current_price", function() {
          var compare_at_price = parseFloat($(".was_price").text().replace("$",""));
          var current_price = parseFloat($(".current_price").text().replace("$",""));
          console.log(compare_at_price + ", " + current_price);
          var price_compare = Math.round((compare_at_price - current_price) / compare_at_price * 100);
          var dollar_compare =(compare_at_price - current_price).toFixed(2);
          $('.percent_saved').html(price_compare);
          $('.dollar_saved').html(dollar_compare);
        });
      } else {
        $('.was_price', $product).text('')
      }

      if (variant.inventory_management && variant.inventory_quantity > 0) {
        
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      } else {
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
      }

      $('.sold_out', $product).text('');
      if (variant.price > 0) {
        $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
      } else {
        $('.current_price', $product).html("Free");
      }
      $("#shopmessage-checkbox").fadeOut("fast");
      
    } else {
      $("#shopmessage-checkbox").fadeIn("fast");
      
      }

      

      $('.product_form .loadingMsg').hide();
      $('.product_form .waitUntilLoaded').show();
      };
      });

      function htmlEncode(value){
      if (value) {
      return $('<div/>').text(value).html();
      } else {
      return '';
      }
      }
      /* option_selection.js */
      function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};


   /*ajax cart*/
  window.refreshCart = function(cart) { 
    console.log(cart);
    if (window.discountCode){
      window.chCouponCode = window.discountCode;
    }
    if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1))
    {
      window.location = '/cart';
    }
    $cartBtn = $(".icon-cart");
    $cartBtnTxt = $(".icon-cart span");
    if ($cartBtn && $cartBtnTxt.length) {
      var value = $cartBtnTxt.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      //$cartBtnTxt.text(value.replace(/[0-9]+/,cart.item_count));
      var hasFreeShip = false;
      $.each(cart.items, function(index, item) {
        if(item.handle == "free-shipping"){
          hasFreeShip = true;
        }
      });
      if(hasFreeShip){
        $cartBtnTxt.text(value.replace(/[0-9]+/,cart.item_count - 1));
      } else {
        $cartBtnTxt.text(value.replace(/[0-9]+/,cart.item_count));
      }
      if (cart.item_count == 0) {
        SubInCart = true;
        $(".upsell_item_body").hide();
        $(".empty_cart").css("display","");
        $(".full_cart").fadeOut("fast");
        $(".qualifying_discount").removeClass("qualified");
      } else {

        $(".upsell_item_body").show();           
        $(".empty_cart").css("display","none");
        $(".full_cart").fadeIn("fast");
        $(".cart_item.full_cart").remove();
        var cart_itemUrl = "",
            cart_prodTitle = "",
            cart_varTitle = "";
        $.each(cart.items, function(index, item) {

          if(item.line_level_discount_allocations[0] != undefined){console.log(item.line_level_discount_allocations[0]);}
          cart_itemUrl = item.url;
          cart_prodTitle = item.product_title;
          if(cart_prodTitle.indexOf("Auto")>-1){
            cart_itemUrl = cart_itemUrl.replace("-1?", "?");
          }else{
            SubInCart=false;
          }
          if(cart_prodTitle.indexOf("Free Shipping Initiator") < 0){
            
            cart_items_html += '<li class="cart_item full_cart cart_item_' + item.handle + '"> <div class="cart_item_body"> <img src="' + item.image.replace(/(\.[^.]*)$/, "_120x$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + 
              '<div class="itemdetails_container"> <div class="itemtitle">' + cart_prodTitle +
              '</div>';
          
              if (item.variant_title){
              if (item.variant_title.indexOf("default")===-1) {
                cart_items_html += '<div class="itemtype">' + item.variant_title + '</div>';
              }
            }else{cart_items_html += '<div class="itemtype"> </div>';}
          //  if(item.line_level_discount_allocations[0] != undefined)
            //{
              var discounted_price = item.discounted_price;
              if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.indexOf('prepaid') > -1) {
                discounted_price = discounted_price / 3;
              }
              cart_items_html +='<div class="itemprice newprice">' + Shopify.formatMoney(discounted_price, $cart.data('money-format')) + '</div>' 
           // }  
            cart_items_html += '<div class="itemprice';
            var price_showing=item.price;

          //  if(item.line_level_discount_allocations[0] != undefined)
           // {
              cart_items_html +=' compare';
              if(item.properties.compare_at_price){
                price_showing=item.properties.compare_at_price;
              }
              
            //}

            cart_items_html += '">'+ Shopify.formatMoney(price_showing, $cart.data('money-format')) +'</div>';

            if (item.selling_plan_allocation) {
              cart_items_html += '<span class="itemsellingplanname">' + item.selling_plan_allocation.selling_plan.name + '</span>';
            }
            cart_items_html += '<div><div class="mm-counter mm-counter_' + item.id + ' mm-counter_input"';
            if (item.price < 100){
              cart_items_html += 'style="display:none"';
            }
            cart_items_html += '>';
            if(!item.variant_title){
              if(item.title.toLowerCase().indexOf("system")<0 || item.title.toLowerCase().indexOf("bundle")<0){cart_items_html +='<span class="ss-icon minus">&#x002D;</span>';}
            }else{
             // if(item.variant_title.toLowerCase().indexOf("1 ") >-1 || item.variant_title.toLowerCase().indexOf("single") >-1 || item.variant_title.toLowerCase().indexOf("presale") >-1 ||item.variant_title.toLowerCase().indexOf("3 ") >-1 || item.product_title.toLowerCase().indexOf("new year") >-1){
                cart_items_html +='<span class="ss-icon minus">&#x002D;</span>';
              //}
            }
            cart_items_html += '<input type="text" pattern="[0-9]" maxlength="1" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />';
            
            if(!item.variant_title){

              if(item.title.toLowerCase().indexOf("system")<0 || item.title.toLowerCase().indexOf("bundle")<0)
              {
                cart_items_html +='<span class="quantity_num">'+item.quantity+'</span><span class="ss-icon plus">&#x002B;</span>';}
            
            }else{
            
              //if(item.variant_title.toLowerCase().indexOf("1 ") >-1 || item.variant_title.toLowerCase().indexOf("single") >-1 || item.variant_title.toLowerCase().indexOf("presale") >-1 ||item.variant_title.toLowerCase().indexOf("3 ") >-1 || item.product_title.toLowerCase().indexOf("new year") >-1){
                cart_items_html +='<span class="quantity_num">'+item.quantity+'</span><span class="ss-icon plus">&#x002B;</span>';
             // }
            }

            cart_items_html +='<span class="trashcan trashcan_' + item.id + '">Remove</span></div></div>';
            cart_items_html +='<div class="SaveAppContaine" product_id="'+item.product_id+'"  variant_id="'+item.id+'" cAtPrice="'+item.properties.compare_at_price+'">'+
            '<og-offe product="'+item.variant_id+'" location="pdp" os-version="1" subscribed="" frequency="2_3"><og-when test="regularEligible">'+
            '</og-offe>'+
            '</li></div></div>';
          }
     
        });
        setTimeout(function(){
          
          $('og-optout-button').click(function(){
            qty=$(this).closest(".SaveAppContainer").closest('.itemdetails_container').find('.quantity_num').html()
            updateSubscrib($(this).closest(".SaveAppContainer").attr("product_id"),$(this).closest(".SaveAppContainer").attr("variant_id"),true,qty,$(this).closest(".SaveAppContainer").attr("cAtPrice"))
          })
          $('og-optin-button').click(function(){
            qty=$(this).closest(".SaveAppContainer").closest('.itemdetails_container').find('.quantity_num').html()
            updateSubscrib($(this).closest(".SaveAppContainer").attr("product_id"),$(this).closest(".SaveAppContainer").attr("variant_id"),false,qty,$(this).closest(".SaveAppContainer").attr("cAtPrice"))
         })
         },1000)
        var ics = "";
        if(cart.item_count > 1){
          ics = 's'};
        $('.cart-item-count').html('('+cart.item_count +' item' + ics + ')');
        $('.ot_subtotal').text(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));
        $cart.prepend(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
   
          
    
        
      }
    }
  }   
  
  setTimeout(function(){
    
 $('og-optout-button').click(function(){
  qty=$(this).closest(".SaveAppContainer").closest('.itemdetails_container').find('.quantity_num').html()
  updateSubscrib($(this).closest(".SaveAppContainer").attr("product_id"),$(this).closest(".SaveAppContainer").attr("variant_id"),true,qty,$(this).closest(".SaveAppContainer").attr("cAtPrice"))
 })
 $('og-optin-button').click(function(){
  qty=$(this).closest(".SaveAppContainer").closest('.itemdetails_container').find('.quantity_num').html()
  updateSubscrib($(this).closest(".SaveAppContainer").attr("product_id"),$(this).closest(".SaveAppContainer").attr("variant_id"),false,qty,$(this).closest(".SaveAppContainer").attr("cAtPrice"))
})
},1000)

function updateSubscrib(product_id, variant_id, subsc ,qty,compare_at_price){
if(subsc){
  data = {
    "quantity":0,
   "id": variant_id,
   "properties":{compare_at_price:compare_at_price},
 } 
 data2 = {
   "quantity":qty,
    "id": variant_id,
    "properties":{compare_at_price:compare_at_price},
}
}else{
   data = {
     "quantity":0,
    "id": variant_id,
    "properties":{compare_at_price:compare_at_price},
  } 
  data2 = {
    "quantity":qty,
     "id": variant_id,
     "line":2,
     "selling_plan":"787742901",
     "properties":{compare_at_price:compare_at_price},
 } 
  
}
jQuery.ajax({
  type: 'POST',
  url: '/cart/change.js',
  data: data,
  dataType: 'json',
  cache: false,
  success: function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data2,
      dataType: 'json',
      cache: false,
      success: function() {
        jQuery.ajax({
          type: 'GET',
          url: '/cart.js',
          data: data2,
          dataType: 'json',
          cache: false,
          success: function(dataa2) {
            console.log(dataa2)
            refreshCart(dataa2);
            if(typeof templ !== 'undefined')
            location.reload()
         
          }
        });
        

      }
    });
  }
}); 



}